// @flow

import * as React from "react";
import Textarea from "react-textarea-autosize";

import "./Scratchpad.css";

const Scratchpad = () => {
  return (
    <div className="Scratchpad">
      <Textarea
        minRows={2}
        placeholder="This is your scratchpad. You may jot down any notes you have while thinking here."
      />
    </div>
  );
};

export default Scratchpad;



// WEBPACK FOOTER //
// ./src/components/Scratchpad/Scratchpad.js